// src/hooks/useDatabaseTables.js
import { useState, useEffect } from 'react';

export default function useDatabaseTables(API_URL) {
  const [resultsTable, setResultsTable] = useState([]);
  const [selectedTable, setSelectedTable] = useState("");
  const [results, setResults] = useState(null);

  // Fetch elenco tabelle
  useEffect(() => {
    async function fetchTables() {
      try {
        const res = await fetch(`${API_URL}/getTablesDB`, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        });
        if (!res.ok) throw new Error("Nessuna tabella trovata");
        const data = await res.json();
        setResultsTable(data);
      } catch (err) {
        alert(err.message);
      }
    }
    fetchTables();
  }, [API_URL]);

  // Fetch dati tabella
  const fetchTableData = async (tableName) => {
    if (!tableName) return;
    try {
      const res = await fetch(`${API_URL}/readDB`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ tableName }),
      });
      if (!res.ok) throw new Error("Errore lettura dati");
      const data = await res.json();
      setResults(data);
    } catch (err) {
      alert(err.message);
    }
  };

  const resetResults = () => setResults(null);

  return {
    resultsTable,
    selectedTable,
    setSelectedTable,
    results,
    setResults,
    fetchTableData,
    resetResults,
  };
}
